import Vue from "vue";
import Vuex from "vuex";
import { globalConfig } from "../config";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    web3: null,
    globalConfig: globalConfig,
    tokens: [],
  },
  getters: {
    web3Enabled: (state) => state.web3 !== null,
  },
  mutations: {},
});

export default store;
